export default __webpack_public_path__ + "static/media/payment_icon.872961ec.svg";